import { Kind, parse, visit, type DocumentNode } from 'graphql';

const selection = parse(`query { users { paymentTransactions {
  _id date source providerPaymentId status amount paidAmount debt lessons currency
} remainingPaidLessons totalPaidAmount } }`).definitions[0] as any;
const extraFields = selection.selectionSet.selections[0].selectionSet.selections;
const create = parse(`mutation($memberPayments: [StudentGroupMemberPaymentInput!]) {
  createOneUserGroupMutation(memberPayments: $memberPayments) { __typename }
}`).definitions[0] as any;

export function withGroupPayments(document: DocumentNode): DocumentNode {
  return visit(document, {
    Field(node) {
      if (node.name.value === 'users' && node.selectionSet?.selections.some((field: any) => field.kind === Kind.FIELD && field.name.value === 'user')) {
        return { ...node, selectionSet: { ...node.selectionSet, selections: [...node.selectionSet.selections,
          ...extraFields.filter((field: any) => !node.selectionSet!.selections.some((old: any) => old.name?.value === field.name.value))] } };
      }
      if (node.name.value === 'createOneUserGroupMutation' && !node.arguments?.some(arg => arg.name.value === 'memberPayments'))
        return { ...node, arguments: [...(node.arguments ?? []), ...create.selectionSet.selections[0].arguments] };
    },
    OperationDefinition(node) {
      if (node.operation === 'mutation' && node.selectionSet.selections.some((field: any) => field.name?.value === 'createOneUserGroupMutation') &&
          !node.variableDefinitions?.some(variable => variable.variable.name.value === 'memberPayments'))
        return { ...node, variableDefinitions: [...(node.variableDefinitions ?? []), ...create.variableDefinitions] };
    },
  });
}
